var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoLocationFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 75,
    viewBox: "0 0 71 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4746 57.9491C44.2006 57.9491 56.9491 45.2006 56.9491 29.4746C56.9491 13.7485 44.2006 1 28.4746 1C12.7485 1 0 13.7485 0 29.4746C0 45.2006 12.7485 57.9491 28.4746 57.9491Z",
    fill: "#CCE7E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 25.9153H20.1694V63.8814H69.9999V25.9153Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5255 36.5932H8.30518V73.3729H41.5255V36.5932Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5255 67.4407V73.3729H8.30518V36.5932H16.6103",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1694 63.8813V66.2542L40.3389 72.1864H41.5253V67.4407",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2931 64.1068L52.2032 52.017H35.5931L29.6609 46.0848L34.4066 41.339L36.7795 43.7119H54.5761L69.9998 59.1356",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3557 46.0848L33.2201 57.9492H49.8303L55.7625 63.8814",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3557 28.2882L29.6608 36.5932L24.915 41.339L21.3557 37.7797",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 50.8305L56.9491 37.7797H39.1525L27.2881 25.9153",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1353 25.9153L69.9997 37.7797",
    stroke: "#00857C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 25.9153H20.1694V63.8814H69.9999V25.9153Z",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.717 1.78308C49.6396 1.78308 47.5827 2.19262 45.6638 2.98829C43.7449 3.78397 42.0017 4.95017 40.5339 6.42016C39.0661 7.89016 37.9025 9.63511 37.1097 11.5552C36.3169 13.4753 35.9105 15.5329 35.9136 17.6102C35.9136 31.2542 49.3915 33.1051 50.5187 46.9746C50.5187 47.2892 50.6437 47.591 50.8662 47.8135C51.0887 48.036 51.3904 48.161 51.7051 48.161C52.0198 48.161 52.3216 48.036 52.5441 47.8135C52.7666 47.591 52.8915 47.2892 52.8915 46.9746C54.0187 33.1051 67.5085 31.2542 67.5085 17.6102C67.5116 15.5339 67.1055 13.4773 66.3135 11.5579C65.5214 9.63862 64.3589 7.8942 62.8924 6.42436C61.4258 4.95453 59.6841 3.78809 57.7665 2.99172C55.849 2.19534 53.7933 1.78464 51.717 1.78308Z",
    fill: "#08C296",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2117 11.4288L57.2218 22.439",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2117 22.439L57.2218 11.4288",
    stroke: "#19213E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationFound);
export default __webpack_public_path__ + "static/media/no-location-found.e9f44a264d9a757d6490e14096256bef.svg";
export { ForwardRef as ReactComponent };